<template>
	<div class="container" v-if="dicrelevants.length >0 ">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="category">
            <a class="category-top">相关词条</a>
            <a class="category-bottom">Relevant noun</a>
          </div>
        </div>
        <div class="panel-body" style="padding:0px 5px;">
          <ul class="noun">
            <li v-for="item in dicrelevants">
              <router-link :to="{ name: item.type, params: { id: item.DicNO }}"><span>{{item.DicName}}</span><span class="righttxt">ID:{{item.DicNO}} </span></router-link>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>
<script>

export default {
  data(){
    return {
      show: false
    }
  },
  props: {
  	dicrelevants: {
  		type: Array||Object,
  		require: true
  	}
  },
  components: {  },
  mounted: function () {
  },
  methods: {
  }
};

</script>
<style>
 .righttxt{
   color: #9c8a85;
   font-weight: normal;
 }
</style>